export const  timeFromString = (time:string):number => {
  if(!time) return 0
  const parts = time.split(':')  
  return Number.parseInt(parts[0]) * 3600000 + Number.parseInt(parts[1]) * 60000
}